import { Button } from "@gigpro/ui/Button";
import { Dialog, DialogFooter, DialogTitle } from "@gigpro/ui/Dialog";
import { Textfield } from "@gigpro/ui/Textfield";
import { toast } from "@gigpro/ui/Toast";
import { useAdminBackgroundChecksCreate } from "@sidegigllc/api/client";
import React from "react";
import { toastApiError } from "utils/toastApiError";

type Props = {
  onClose: () => void;
  open: boolean;
  proId: number;
};

export function ModalBackgroundCheckLink({ proId, onClose, open }: Readonly<Props>) {
  const [email, setEmail] = React.useState<string>("");

  const createBackgroundCheck = useAdminBackgroundChecksCreate();

  const handleOnSubmit = async () => {
    try {
      await createBackgroundCheck.mutateAsync({ data: { email: email, pro_id: proId } });
      toast.success(`Background check link successfully sent to ${email}`);
    } catch (e) {
      toastApiError(e);
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Send Background Check Link</DialogTitle>
      <Textfield
        name="email"
        label="Enter email address to receive link"
        placeholder="email@example.com"
        onChange={(e) => setEmail(e.target.value)}
      />
      <DialogFooter>
        <Button size="small" onClick={handleOnSubmit} variant="contained" loading={createBackgroundCheck.isPending}>
          Send Link
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
